export default "__VITE_ASSET__D88sLuaA__"